<template>
	<div class="header-top">
		<cIndex></cIndex>
		<div class="container">
			<div class="container-div">
				<div class="banner">
					<div class="swiper-container">
					    <div class="swiper-wrapper">
					        <div class="swiper-slide">
					        	<img src="../assets/banner6.png"/>
					        </div>
					        <div class="swiper-slide">
					        	<img src="../assets/banner2.png"/>
					        </div>
					        <div class="swiper-slide">
					        	<img src="../assets/banner3.png"/>
					        </div>
					    </div>
					    <!-- 如果需要分页器 -->
					    <div class="swiper-pagination"></div>
					    
					    <!-- 如果需要导航按钮 -->
					    <div class="swiper-button-prev swiper-button"></div>
					    <div class="swiper-button-next swiper-button"></div>
					</div>
				</div>
				<div class="edition">
					<ul>
						<li @click="goPayment(1)"><img src="../assets/guide1.png" alt="图片"><span>青年版（17-44周岁）</span></li>
						<li @click="goPayment(2)"><img src="../assets/guide2.png" alt="图片"><span>中年版（45-60周岁）</span></li>
						<li @click="goPayment(3)"><img src="../assets/guide3.png" alt="图片"><span>老年版（60周岁以上）</span></li>
						<li @click="goPayment(4)"><img src="../assets/guide4.png" alt="图片"><span>儿童版（5-16周岁）</span></li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import cIndex from '@/components/header'
	const components = {
		cIndex
	}
	export default {
		components: components,
		data() {
			return {
				editionList: [
					{
						imgSrc: '../assets/01.png',
						title: '青年版（17-44周岁）'
					},
					{
						imgSrc: '../assets/guide2.png',
						title: '中年版（45-60周岁）'
					},
					{
						imgSrc: '../assets/guide3.png',
						title: '老年版（60周岁以上）'
					}
				],
				mySwiper: null
			}
		},
		created(){
			var _this = this;
			setTimeout(function(){
				_this.mySwiper = new Swiper('.swiper-container',{
						direction: 'horizontal',
    					loop: true,
    					// 如果需要分页器
					    pagination: '.swiper-pagination',
					    
					    // 如果需要前进后退按钮
					    nextButton: '.swiper-button-next',
					    prevButton: '.swiper-button-prev',
					    autoplay: 5000
				})
			},200)
			
		},
		methods: {
			goPayment(ind){
				this.$router.replace({path:'/payment',query: {pID: ind}})
			}
		}
	}
</script>
<style lang="scss">
	@import "../styles/core/reset.scss";
	@import "../styles/common/swiper-3.4.2.min.css";
	.header-top{
		width: 100%;
		height: 100%;
		@include flexbox;
		@include flex-direction(column);
		.container{
			@include flex;
			width: 100%;
			overflow-y: auto;
			.container-div{
				width: 12rem;
				margin: 30px auto;
				.banner {
					height: 4rem;
					border: 1px solid #C9C9C9;
					.swiper-container{
						height: 4rem;
						.swiper-wrappe{
							height: 4rem;
							.swiper-slide{
								height: 4rem;
							}
						}
						.swiper-pagination{
							span{
								display: inline-block;
								width: .3rem;
								height: .05rem;
								border: 1px solid #CBCBCB;
								border-radius: 0.02rem;
								box-sizing: border-box;
							}
						}
						.swiper-button{
							width: .4rem;
							height: .6rem;
		
						}
		
						.swiper-button-prev{
							background: url(../assets/next-on.png) no-repeat left center;
							background-size: 100%;
							left: 0;
						}
						.swiper-button-next{
							background: url(../assets/next.png) no-repeat left center;
							background-size: 100%;
							right: 0;
						}
						.swiper-button-prev:hover{
							background: url(../assets/prev.png) no-repeat left center;
							background-size: 100%;
							left: 0;
						}
						.swiper-button-next:hover{
							background: url(../assets/next-hover.png) no-repeat left center;
							background-size: 100%;
							right: 0;
						}
					}
				}
				.edition{
					width: 100%;
					height: 2.95rem;
					margin-top: .80rem;
					ul{
						width: 100%;
						height: 2.95rem;
						@include flexbox;
						li{
							@include flex;
							@include flexbox;
							@include flex-direction(column);
							cursor: pointer;
							justify-content: center;
							align-items: center;
							&:not(:nth-child(1)){
								margin-left: 0.08rem;
							};
							img{
								display: block;
								width: 100%;
								// height: 2.3rem;
								// border: 1px solid #eee;
							}
							span{
								text-align: center;
								padding-top: .2rem;
								font-size: .18rem;
								color: #555555;
							}
						}
					}
				}	
			}
			
		}
	}
	
	
</style>


// WEBPACK FOOTER //
// guide.vue?57781be9